<template>
  <div>
    <div v-if="deferredPrompt && random > 50" class="text-center pa-2">
      <v-btn color="primary" text @click="install">
        <v-icon dark left>
          mdi-download
        </v-icon>
        {{ $t('install') }}
      </v-btn>
      <div class="caption text--secondary">{{ $t('install-app') }}
      </div>
    </div>

    <div class="pa-2 text-center">
      <v-btn v-if="false" :ripple="false" text x-small>Confidentialité</v-btn>
      <v-btn v-if="false" :ripple="false" text x-small>Conditions</v-btn>
      <v-btn :ripple="false" text x-small @click="$ui.openDialog('legal_notice')">Mentions</v-btn>
      <v-btn :ripple="false" text x-small @click="$ui.openDialog('terms_of_service')">CGU</v-btn>
    </div>

    <!--    <div class="pa-2 text-center mb-4" style="font-size: 12px;">
            <span v-if="heart.hit < 5">
              {{ $t('dev-with') }}
              <v-icon :style="'font-size: ' + heart.current + 'px'" color="#E7272D">{{ heart.icon }}</v-icon>
              {{ $t('by') }}
              <a target="_blank" @mouseover="heartOn" @mouseleave="heartOff" href="https://sauce-code.fr/"
                 style="color: #E7272D; font-weight: 500;">Sauce Code</a>
            </span>
          <span v-else>
            {{ $t('easter-egg') }} <v-icon style="font-size: 16px;" color="#E7272D">mdi-bomb</v-icon>
            </span>
        </div>-->
  </div>
</template>

<script>
export default {
  name: 'AppNavigationFooter',
  data() {
    return {
      heart: {
        random: /*Math.round(Math.random() * 100)*/ 0,
        hit: 0,
        hit_interval: null,
        icon: 'mdi-heart',
        icons: ['mdi-arm-flex', 'mdi-beer', 'mdi-fire', 'mdi-flash', 'mdi-ghost', 'mdi-lightbulb-on', 'mdi-wrench'],
        current: null,
        min: 12,
        max: 16
      },
      deferredPrompt: null,
    }
  },
  methods: {
    async install() {
      this.deferredPrompt.prompt()
    },
    heartOn() {
      this.heart.hit++
      this.heart.icon = this.heart.icons[Math.floor(Math.random() * this.heart.icons.length)]
      this.heart.current = this.heart.max
    },
    heartOff() {
      this.heart.icon = 'mdi-heart'
      this.heart.current = this.heart.min
    },
    getTwitterLink() {
      return 'https://twitter.com/CheckPosition'
    },
    getEmailLink() {
      return 'mailto:michael@check-position.com'
    },
    getSlackLink() {
      return 'https://check-position.com/slack'
    }
  },
  created() {
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      this.deferredPrompt = e
    })
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null
    })

    this.heart.current = this.heart.min
    setTimeout(() => {
      this.heart.current = this.heart.max
      setTimeout(() => this.heart.current = this.heart.min, 250)
    }, 2000)

    this.hit_interval = setInterval(() => {
      this.heart.hit = 0
    }, 5000)
  },
  destroyed() {
    clearInterval(this.hit_interval)
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "by": "By",
    "dev-with": "Developed with",
    "easter-egg": " Aaaahhhhh, you broke everything!",
    "install": "Install",
    "install-app": "See your positions faster by installing this application on your computer or smartphone."
  },
  "es": {
    "by": "Por",
    "dev-with": "Desarrollado con ",
    "easter-egg": " Aaaahhhhh, ¡rompiste todo!",
    "install": "Instalar",
    "install-app": "Vea sus posiciones más rápido instalando esta aplicación en su computadora o teléfono inteligente."
  },
  "fr": {
    "by": "par",
    "dev-with": "Développé avec",
    "easter-egg": " Aaaahhhhh, vous avez tout cassé ! ",
    "install": "Installer",
    "install-app": "Consultez vos positions plus rapidement en installant cette application sur votre ordinateur ou smartphone."
  },
  "it": {
    "by": "Da",
    "dev-with": "Sviluppato con",
    "easter-egg": " Aaaaahhh, hai rotto tutto!",
    "install": "Installa",
    "install-app": "Consulta le tue posizioni più rapidamente installando questa applicazione sul tuo computer o smartphone."
  },
  "pt": {
    "by": "Por",
    "dev-with": "Desenvolvido com",
    "easter-egg": " Aaaahhhhh, partiste tudo!",
    "install": "Instalar",
    "install-app": "Consulte as suas posições mais rapidamente instalando esta aplicação no seu computador ou smartphone."
  },
  "pl": {
    "by": "Przez",
    "dev-with": "Opracowane z",
    "easter-egg": " Aaaahhhhh, zepsułeś wszystko!",
    "install": "Zainstaluj",
    "install-app": "Przeglądaj swoje pozycje szybciej, instalując tę aplikację na swoim komputerze lub smartfonie."
  }
}
</i18n>
